/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useAuth } from "../../store/useAuth";
import { BeevisionMachineTable } from "./BeevisionMachineTable";
import { useBeevisionMachines } from "../../store/useBeevisionMachines";

function TomraMachinesScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { user } = useAuth();
  const { getBeevisionMachines, allBeevisionMachines } = useBeevisionMachines();
  /** State */
  const [page /* setPage */] = useState(1);

  const addMachine = () => navigate("/add-beevision-machine");

  useEffect(() => {
    getBeevisionMachines(page, 20);
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Beevision Machines
        </h1>
        {user?.user_role === 1 || user?.user_role === 7 ? (
          <div className="flex flex-col sm:flex-row justify-end sm:items-center">
            <PrimaryButton
              onClick={addMachine}
              label="Register new Beevision Machine"
              className="h-10 mb-1 sm:mb-0"
            />
          </div>
        ) : null}
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!allBeevisionMachines?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Beevision machine created yet.
          </p>
        ) : (
          <BeevisionMachineTable />
        )}
      </div>
      {/* {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              setPage(page + 1);
              getArticles(page + 1, 20);
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null} */}
    </div>
  );
}

export default withProtectedRoute(TomraMachinesScreen);
